import { MouseEvent } from 'react';

import { REWIND_SLIDES, RewindSlideId } from '../../rewindModal.types';

import styles from './slideProgressBar.module.scss';

interface SlideProgressBarProps {
  currentSlideIndex: number;
  progress: number;
  onSlideClick: (index: number) => void;
}

export function SlideProgressBar({
  currentSlideIndex,
  progress,
  onSlideClick,
}: SlideProgressBarProps): JSX.Element {
  const handleSegmentClick = (event: MouseEvent, index: number): void => {
    event.stopPropagation();
    onSlideClick(index);
  };

  const getSegmentAriaLabel = (
    slideId: RewindSlideId,
    index: number,
  ): string => {
    const slideNames: Record<RewindSlideId, string> = {
      opening: 'Opening',
      journey: 'Your Journey',
      impact: 'Your Impact',
      style: 'Your Style',
      wins: 'Your Wins',
      closing: 'Closing',
    };
    return `Go to slide ${index + 1}: ${slideNames[slideId]}`;
  };

  return (
    <div
      className={styles.progressBar}
      role="tablist"
      aria-label="Slide progress"
      data-capture-ignore
    >
      {REWIND_SLIDES.map((slideId, index) => {
        const isCompleted = index < currentSlideIndex;
        const isCurrent = index === currentSlideIndex;

        let fillPercentage = 0;
        if (isCompleted) {
          fillPercentage = 100;
        } else if (isCurrent) {
          fillPercentage = progress;
        }

        return (
          <button
            key={slideId}
            type="button"
            role="tab"
            aria-selected={isCurrent}
            aria-label={getSegmentAriaLabel(slideId, index)}
            className={`${styles.segment} ${isCurrent ? styles.active : ''}`}
            onClick={(event) => handleSegmentClick(event, index)}
          >
            <div
              className={styles.segmentFill}
              style={{ width: `${fillPercentage}%` }}
            />
          </button>
        );
      })}
    </div>
  );
}
